import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils } from '@fortawesome/free-solid-svg-icons';
import { QRCode } from 'antd';
import dayjs from 'dayjs';

import './FoodReady.less';

const FoodReady = ({ orderData }) => {
	const { start_time, end_time, price, meal_name, drink_name, display_id, token, locker_name, order_customizations } = orderData;
	const drinkCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'drink') : null;
	const mealCustomizations = order_customizations ? order_customizations.filter(item => item.customization_type === 'meal') : null;

	const total = price + order_customizations.reduce((sum, item) => sum + item.option_price || 0, 0);

	return (
		<div className="food-ready">
			<div className="food-ready-header">
				<div className="food-ready-icon-wrapper">
					<FontAwesomeIcon
						icon={faUtensils}
						className="food-ready-icon"
					/>
				</div>
				<h2 className="food-ready-title">可取餐 Food is Ready</h2>
				{/* <p className="food-ready-subtitle">
					You may now pick up your meal at the designated food locker.
				</p> */}
			</div>

			<div className="order-details-section">
				<div className="qr-code-section">
					<QRCode
						value={token}
						size={300}
						className="qr-code-image"
					/>
				</div>

				<div className="order-status-badge ready">
					<span>可取餐 Ready for Pickup</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單編號 Order ID</span>
					<span className="detail-value">{display_id}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">取餐時段 Pickup Timeslot</span>
					<span className="detail-value">{start_time && end_time ? `${dayjs(start_time).format('HH:mm')}-${dayjs(end_time).format('HH:mm')}` : 'N/A'}</span>
				</div>


				<div className="order-detail-row">
					<span className="detail-label">食物櫃 Food Locker</span>
					<span className="detail-value">{locker_name}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">訂單摘要 Order Summary</span>
					<div className="detail-value">
						<div>• {meal_name}</div>
						{mealCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{mealCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
						{drink_name && <div>• {drink_name}</div>}
						{drinkCustomizations &&
							<ul style={{ listStyle: 'circle' }}>
								{drinkCustomizations.map(option => (
									<li>{option.option_name}</li>
								))}
							</ul>
						}
					</div>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">總額 Total</span>
					<span className="detail-value">${total.toFixed(2)}</span>
				</div>

				<div className="order-detail-row">
					<span className="detail-label">下一步? What happens next?</span>
					<div className="detail-value">
						<div>• 我們已準備好您的訂單。</div>
						<div>• 請於選定取餐時段內，使用二維碼到指定食物櫃領取餐點。</div>
						<div>• 您只可在選定的取餐時段內領取餐點。若逾時未取餐，基於食物安全及衛生考慮，該餐點將被棄置，我們不會提供任何補償或退款。</div>
					</div>
					<br />
					<div className="detail-value">
						<div>• Your order is ready for pickup.</div>
						<div>• Use the QR Code to pick up your meal at the designated food locker during your selected timeslot.</div>
						<div>• You may only collect your order during the selected pickup timeslot. If not collected on time, the meal will be discarded for food safety and hygiene reasons. No compensation or refund will be provided in such cases.</div>
					</div>
				</div>

				{/* <div className="how-to-collect">
					<h3 className="how-to-collect-title">How to collect your meal</h3>
					<ul className="how-to-collect-list"></ul>
				</div> */}
			</div>
		</div>
	);
};

export default FoodReady;
